export const WILDFIRE_ICONS_LAYER_ID = 'geo-event-icons';
export const COMPLEX_WILDFIRE_ICONS_LAYER_ID = 'geo-event-complex-icons';
export const WILDFIRE_LABELS_LAYER_ID = 'geo-event-labels';
export const COMPLEX_WILDFIRE_LABELS_LAYER_ID = 'geo-event-complex-labels';
export const COMPLEX_WILDFIRE_PARENT_CHIP_LAYER_ID =
  'geo-event-complex-parent-chip';
export const WILDFIRE_LABELS_MIN_ZOOM = 7;
export const WILDFIRE_INACTIVE_LABELS_MIN_ZOOM = 9;
export const PRESCRIBED_FIRES_LABEL_MIN_ZOOM = 11;
